import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { SSettingsProfile } from '@slg/web-customer-shared';
import { useStore, useGlobalErrorDialog } from '@/composables';


const __default__ = {
  name: 'SettingsProfile',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const { setGlobalError } = useGlobalErrorDialog();

const getUserDetailsForBookingDetails = computed(() => store.getters['auth/getUserDetailsForBookingDetails']);
const getFirstLetters = computed(() => store.getters['auth/getFirstLetters']);

function setGlobalLoading(loadingState: boolean) {
  store.commit('common/setGlobalLoading', loadingState);
}

async function populateUserProfileInfo() {
  try {
    await store.dispatch('auth/populateUserProfileInfo');
  } catch (e) {
    await setGlobalError(e as any);
  }
}

return { __sfc: true,store, setGlobalError, getUserDetailsForBookingDetails, getFirstLetters, setGlobalLoading, populateUserProfileInfo, SSettingsProfile }
}

})